import { render, staticRenderFns } from "./Duvida.vue?vue&type=template&id=07cc9872&scoped=true&lang=pug&"
import script from "./Duvida.vue?vue&type=script&lang=js&"
export * from "./Duvida.vue?vue&type=script&lang=js&"
import style0 from "./Duvida.styl?vue&type=style&index=0&id=07cc9872&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc9872",
  null
  
)

export default component.exports